import Footer from "../../components/footer/Footer";
import NavBar from "../../components/navbar/NavBar";
import BenefitSection from "./components/BenefitSection";
import FAQSection from "./components/FAQSection";
import HeroSection from "./components/HeroSection";
import TestimonialSection from "./components/TestimonialSection";

const Home = () => {
  return (
    <div>
      <div className="mx-3 lg:mx-20">
        <section>
          <NavBar />
        </section>
        <section>
          <HeroSection />
        </section>
        <section>
          <BenefitSection />
        </section>
        <section>
          <TestimonialSection />
        </section>
        <section>
          <FAQSection />
        </section>
      </div>
      <section>
        <Footer />
      </section>
    </div>
  );
};

export default Home;
